import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import format from 'date-fns/format';

import { hideFormSigning, revertForm, signForm } from 'actions/form';

import ModalWrapper from 'components/Modals/ModalWrapper';

class FormSigning extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    formType: PropTypes.string,
    id: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    formData: PropTypes.shape({}),
    isSigningForm: PropTypes.bool,
    isNameInvalid: PropTypes.bool,
    usePreQualifyingQuestionnaire: PropTypes.bool,
  };

  static defaultProps = {
    formType: '',
    id: null,
    formData: null,
    onSubmit: null,
    isSigningForm: false,
    isNameInvalid: false,
    usePreQualifyingQuestionnaire: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      printName: '',
      signDate: '',
      signName: '',
      capacity: ''
    };
  }

  componentDidMount() {
    this.setStateParameters();
  }

  onChangePrintName(event) { this.setState({ signName: event.target.value }); }

  onChangeCapacity(event) { this.setState({ capacity: event.target.value }); }

  onCancel() {
    const { dispatch, id, onCancel } = this.props;
    dispatch(hideFormSigning());
    dispatch(revertForm(id));

    if (onCancel) {
      onCancel();
    }
  }

  onSignForm() {
    const { formType, id, dispatch, onSubmit, formData } = this.props;
    const { capacity, signDate } = this.state;
    let { printName, signName } = this.state;

    if (!printName) {
      printName = '';
    }

    if (!signName) {
      signName = '';
    }

    dispatch(signForm(formType, id, signName || printName, capacity, signDate));

    if (onSubmit) {
      onSubmit(signName, capacity, formData);
    }
  }

  setCapacityField() {
    const { formType } = this.props;
    let capacity = '';
    let elementName = document.getElementsByName('capacityField');
    if (elementName && elementName.length >= 1) {
      capacity = document.getElementById(elementName[0].id);
      if (capacity != null) {
        if (capacity.options[capacity.selectedIndex].text === 'Other') {
          elementName = document.getElementsByName('capacityFieldOther');
          capacity = document.getElementById(elementName[0].id);
          this.setState({ capacity: capacity.value });
          return;
        }
        this.setState({ capacity: capacity.options[capacity.selectedIndex].text });
      }
    } else {
      const form = document.getElementById('blankForm');
      if (form && form.elements) {
        switch (formType) {
          case 'w8ben':
            capacity = form.elements.namedItem('part3.actingCapacity').value;
            break;
          case 'w8ben_2021':
            capacity = null;
            break;
          case 'crsi':
            capacity = form.elements.namedItem('part3.capacity').value;
            break;
          case 'crse':
          case 'crscp':
            capacity = form.elements.namedItem('part4.capacity').value;
            break;
          default:
            break;
        }
      }
      this.setState({ capacity });
    }
  }

  setDateField() {
    const elementName = document.getElementsByName('signdate');
    const signedDate = document.getElementById(elementName[0].id);
    if (signedDate != null) {
      this.setState({ signDate: signedDate.value });
      return signedDate.value;
    }
    return null;
  }

  setStateParameters() {
    const { formType, usePreQualifyingQuestionnaire } = this.props;
    let formPrintName = null;
    let formDate = null;

    if (usePreQualifyingQuestionnaire) {
      switch (formType) {
        case 'w9_2018':
          formPrintName = document.getElementById('W9.Signer.1').value;
          formDate = format(new Date(), 'MM-dd-yyyy');
          break;
        case 'w8ben':
        case 'w8ben_2021':
          formPrintName = document.getElementById('W8BEN.Signer.1').value;
          formDate = format(new Date(), 'MM-dd-yyyy');
          break;
        case 'crsi':
          formPrintName = document.getElementById('CRSI.Signer.1').value;
          formDate = format(new Date(), 'dd-MM-yyyy');
          break;
        case 'crscp':
          formPrintName = document.getElementById('CRSCP.Signer.1').value;
          formDate = format(new Date(), 'dd-MM-yyyy');
          break;
        case 'crse':
          formPrintName = document.getElementById('CRSE.Signer.1').value;
          formDate = format(new Date(), 'dd-MM-yyyy');
          break;
        default:
          formPrintName = null;
          formDate = null;
      }
    }

    const form = document.getElementById('blankForm');
    if (form && form.elements) {
      switch (formType) {
        case 'w8bene_2017':
        case 'w8bene_2021':
          formPrintName = form.elements.namedItem('part30.printName').value;
          formDate = form.elements.namedItem('part30.date').value;
          break;
        case 'w8ben':
        case 'w8ben_2021':
          formPrintName = form.elements.namedItem('part3.printName').value;
          formDate = form.elements.namedItem('part3.date').value;
          break;
        case 'w9_2018':
          formPrintName = form.elements.namedItem('name').value;
          formDate = form.elements.namedItem('certification.date').value;
          break;
        case 'w8eci':
        case 'w8eci_2021':
          formPrintName = form.elements.namedItem('part2.printName').value;
          formDate = form.elements.namedItem('part2.date').value;
          break;
        case 'w8exp':
          formPrintName = form.elements.namedItem('part4.printName').value;
          formDate = form.elements.namedItem('part4.date').value;
          break;
        case 'w8imy_2017':
          formPrintName = form.elements.namedItem('part29.printName').value;
          formDate = form.elements.namedItem('part29.date').value;
          break;
        case 'crsi':
          formPrintName = form.elements.namedItem('part3.printName').value;
          formDate = form.elements.namedItem('part3.dateSigned').value;
          break;
        case 'crse':
          formPrintName = form.elements.namedItem('part4.printName').value;
          formDate = form.elements.namedItem('part4.dateSigned').value;
          break;
        case 'crscp':
          formPrintName = form.elements.namedItem('part4.printName').value;
          formDate = form.elements.namedItem('part4.dateSigned').value;
          break;
        default:
          formPrintName = null;
          formDate = null;
      }
    }

    this.setState({ printName: formPrintName, signDate: formDate });
    this.setCapacityField();
  }

  isW8Form() {
    const { formType } = this.props;
    return formType.indexOf('w8') !== -1;
  }

  isW9Form() {
    const { formType } = this.props;
    return formType === 'w9_2018';
  }

  isCrsForm() {
    const { formType } = this.props;
    return formType.startsWith('crs');
  }

  render() {
    const { isSigningForm, isNameInvalid, usePreQualifyingQuestionnaire } = this.props;
    const { printName, signDate, signName, capacity } = this.state;

    const title = <h1>Signature</h1>;
    const otherFormData = <div>
      { this.isW8Form() && <p>
        <strong className="disclaimer-text">
          The Internal Revenue Service does not require your consent to any provisions of this document other than the certifications required to establish your status as a non-U.S.
          individual and, if applicable, obtain a reduced rate of withholding.
        </strong>
      </p> }
      <p className="pb-2">Print Name<br />
        <span className="cp-primary">{ printName }</span>
      </p>
      <p>Date Given On Form { usePreQualifyingQuestionnaire && `(${ this.isCrsForm() ? 'DD-MM-YYYY' : 'MM-DD-YYYY' })` }<br />
        <span className="cp-primary">{ signDate }</span>
      </p>
      { usePreQualifyingQuestionnaire
        && <p>Capacity<br />
          <span className="cp-primary" name="capacity">{ capacity }</span>
        </p> }
    </div>;
    const w9FormInput = <div>
      <p>
        <strong className="disclaimer-text">The Internal Revenue Service does not require your consent to any provision of this document other than the certifications required to avoid backup withholding.</strong>
      </p>
      <p className="pb-2">Print Name<br />
        {usePreQualifyingQuestionnaire ? <span name="signName">{ printName }</span> : <input type="text" name="signName" value={ signName } onChange={ event => this.onChangePrintName(event) } /> }
      </p>
      <p>Date Given On Form { usePreQualifyingQuestionnaire && '(MM-DD-YYYY)' }<br />
        <span className="cp-primary">{ signDate }</span>
      </p>
      <p className="mb-0">{ usePreQualifyingQuestionnaire ? 'Capacity' : 'Capacity In Which Acting (if not person named on Line 1)'}<br />
        { usePreQualifyingQuestionnaire ? <span name="capacity">{ capacity }</span> : <input type="text" name="capacity" onChange={ event => this.onChangeCapacity(event) } value={ capacity } /> }
      </p>
    </div>;
    const content = <div>
      <p>By clicking the &apos;Sign Form&apos; you confirm that you have reviewed the details in the electronic tax document presented to you and you declare that all statements made in them are correct and complete.
        You will no longer be able to make any changes.</p>
      { this.isW9Form() ? w9FormInput : otherFormData }
      { isNameInvalid && <div className="notifs inline">
        <div className="notif inline error">
          <span>Name on Line 1 and Print Name do not match. Please check these details or provide capacity for signing.</span>
        </div>
      </div> }
    </div>;

    return (
      <ModalWrapper
        title={ title }
        content={ content }
        className={ `modal-signing ${ this.isW9Form() ? 'w9' : '' }` }
        onCancel={ () => this.onCancel() }
        onConfirm={ () => this.onSignForm() }
        showCancel={ false }
        btnConfirmTitle="Sign Form"
        btnConfirmClass={ isSigningForm ? 'btn-active' : '' }
        disableConfirm={ isSigningForm }
        id="form-signing"
      />);
  }
}

function mapStateToProps(state) {
  const {
    form: {
      formData,
      isSigningForm,
      isNameInvalid
    },
    app: { onlineConfig },
  } = state;

  return {
    formData,
    isSigningForm,
    isNameInvalid,
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormSigning);
